// Categorical color palette for block-TYPE icon chips in the "add block" modal.
//
// These colors encode CATEGORY (which kind of block), not status — so, like a
// dataviz categorical palette, they intentionally live OUTSIDE the semantic
// token system (success/warning/destructive/brand). Ported 1:1 from the ref
// (oa-studio-prototype/src/lib/typeColors.ts). Light chip (bg-*-100) + darker
// icon (text-*-700) reads as a colorful chip on the dark editor card.
//
// Assignment is by the card id's stable position below, so known ids get
// distinct, non-colliding colors.

const TYPE_COLOR_PALETTE = [
  'bg-blue-100 text-blue-700',
  'bg-orange-100 text-orange-700',
  'bg-teal-100 text-teal-700',
  'bg-pink-100 text-pink-700',
  'bg-amber-100 text-amber-700',
  'bg-violet-100 text-violet-700',
  'bg-green-100 text-green-700',
  'bg-rose-100 text-rose-700',
  'bg-cyan-100 text-cyan-700',
  'bg-red-100 text-red-700',
  'bg-fuchsia-100 text-fuchsia-700',
  'bg-lime-100 text-lime-700',
  'bg-indigo-100 text-indigo-700',
  'bg-slate-100 text-slate-700',
  'bg-sky-100 text-sky-700',
] as const

// Stable order → distinct color per card id (content first, then interactive).
const CARD_ORDER = [
  'image',
  'video',
  'article',
  'heading',
  'text',
  'audio',
  'design',
  'quiz-single',
  'quiz-multi',
  'match',
  'retired-poll', // слот держит позиции цветов следующих типов
  'yes_no',
  'fill_blank',
  'slider',
  'ordering',
] as const

const hashString = (str: string): number => {
  let hash = 0
  for (let i = 0; i < str.length; i++) hash = (hash * 31 + str.charCodeAt(i)) | 0
  return Math.abs(hash)
}

/** Tailwind `bg-*-100 text-*-700` pair for a card id (distinct per known id). */
export const getTypeChip = (cardId: string): string => {
  const idx = CARD_ORDER.indexOf(cardId as (typeof CARD_ORDER)[number])
  const pos = idx >= 0 ? idx : hashString(cardId)
  return TYPE_COLOR_PALETTE[pos % TYPE_COLOR_PALETTE.length]
}

// Тот же порядок цветов, но только иконка без плашки (окно «Добавить блок»):
// оттенок 400 читается на тёмном фоне. Литералы целиком — Tailwind ищет классы в тексте.
const TYPE_ICON_PALETTE = [
  'text-blue-400',
  'text-orange-400',
  'text-teal-400',
  'text-pink-400',
  'text-amber-400',
  'text-violet-400',
  'text-green-400',
  'text-rose-400',
  'text-cyan-400',
  'text-red-400',
  'text-fuchsia-400',
  'text-lime-400',
  'text-indigo-400',
  'text-slate-400',
  'text-sky-400',
] as const

/** Цвет иконки типа без фона — та же позиция в палитре, что у `getTypeChip`. */
export const getTypeIconColor = (cardId: string): string => {
  const idx = CARD_ORDER.indexOf(cardId as (typeof CARD_ORDER)[number])
  const pos = idx >= 0 ? idx : hashString(cardId)
  return TYPE_ICON_PALETTE[pos % TYPE_ICON_PALETTE.length]
}
